function loadStorage(storageName: string) {
  try {
    const serializedState = localStorage.getItem(storageName);

    if (serializedState === null) {
      return undefined;
    }

    return serializedState ? JSON.parse(serializedState) : serializedState;
  } catch (e) {
    return undefined;
  }
}

function saveToStorage(storageName: string, storageobject: any) {
  try {
    const serializedState = JSON.stringify(storageobject, function replacer(key, value) {
      return value;
    });
    localStorage.setItem(storageName, serializedState);
  } catch (e) {} // tslint:disable-line
}

/**
 * Gets value by key from storage
 * @param storageName
 * @param key
 */
export function getFromLocalStorage(storageName: string, key: string) {
  const persistedState = loadStorage(storageName);
  return persistedState !== undefined ? persistedState[key] : undefined;
}

/**
 * Saves value by key in storage
 * @param storageName
 * @param key
 * @param value
 */
export function saveToLocalStorage(storageName: string, key: string, value: string) {
  let persistedState = loadStorage(storageName);

  if (persistedState === undefined) {
    persistedState = {};
  }

  persistedState[key] = value;
  saveToStorage(storageName, persistedState);
}

/**
 * Removes item by key from storage
 * @param storageName
 * @param key
 */
export const removeFromLocalStorage = (storageName: string, key: string) => {
  const persistedState = loadStorage(storageName);

  if (persistedState !== undefined) {
    delete persistedState[key];
    saveToStorage(storageName, persistedState);
    return true;
  } else {
    return false;
  }
};

/**
 * Clear storage
 * @param storageName
 */
export function clearAllLocalStorage(storageName: string) {
  const persistedState = {};
  saveToStorage(storageName, persistedState);
}
